import React, { useEffect, useState } from "react";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  removeBatchUrlImage,
  setBatchUrlImage,
  setLoader,
} from "../../Redux/MainImage/imageSlice";
import { setTemplate_Changed } from "../../Redux/UserSlice/userSlice";
import { CircularProgress } from "@mui/material";
import { setWaterMarksLoader } from "../../Redux/WaterMarks/wateramarks";

const BatchPreview = ({ userSliceState }) => {
  const [images, setImages] = useState([]);

  const dispatch = useDispatch();
  const file = useSelector((state) => state.mainImage);

  const { t } = useTranslation();
  useEffect(() => {
    if (file.batchurls.length) {
      var images_base64 = file.batchurls?.map((image) => {
        return image.url;
      });
      setImages(images_base64);
    }
  }, [file.batchurls.length]);

  return (
    <Row className="mx-2 px-4 newScroller batchPreview">
      {/* {!(userSliceState.template_Edit) ? ${!(userSliceState.template_Edit) ? "d-flex" : " d-none"} */}
      {/* <Row className={`${!(userSliceState.template_Edit) ? null : " d-none"}`}> */}

      <Row
        className=" head border-bottom m-0 p-0 mb-3 py-3 line_height_100pc text_18 text-uppercase
          d-flex justify-content-start align-items-start
          "
      >
        {" "}
        <p className="productSansBold m-0 px-0 mb-3">{t("BatchPhotos")}</p>
        <p
          className={`text_15 m-0 p-0 productSansLight line_height_100pc batchText`}
        >
          {images.length + t("BatchPhotosDescription")}
        </p>
        {userSliceState.discarded && (
          <div
            style={{ color: "#FF5353" }}
            className="d-flex gap-2 mt-2 px-0 mx-0"
          >
            <WarningAmberRoundedIcon color="danger" />
            <p style={{ textTransform: "none" }} className={`m-0 p-0 aktiv`}>
              Some of the images are not loaded due to unsupported format.
            </p>
          </div>
        )}
      </Row>
      <Row className="text_16 productSansLight mt-1 m-0 p-0 d-grid batchImageGrid">
        {images?.map((url, index) => {
          return (
            <div
              key={index}
              className={`p-0 d-flex flex-column justify-content-center align-items-center`}
              onClick={() => {
                dispatch(setLoader(true));
                if (file.currentIndex !== index) {
                  dispatch(setWaterMarksLoader(true));
                  dispatch(setBatchUrlImage(index));
                  setTimeout(() => {
                    dispatch(setBatchUrlImage(index));
                  }, 100);
                  dispatch(setTemplate_Changed(true));
                }
                setTimeout(() => {
                  dispatch(setWaterMarksLoader(false));
                }, 2000);
                // else {
                //     dispatch(setLoader(false))

                // }
              }}
            >
              {userSliceState.loader && file.currentIndex === index ? (
                <CircularProgress className="themeColor" />
              ) : (
                <img
                  onError={() => {
                    dispatch(
                      removeBatchUrlImage({
                        index: index,
                        setPrevious: false,
                      })
                    );
                  }}
                  onLoad={() => {
                    if (
                      index + 1 === file.batchurls.length &&
                      file.corruptedCount > 0
                    ) {
                      var count = file.corruptedCount;
                      var number = count > 1 ? "pictures" : "picture";
                      alert(
                        count +
                          " " +
                          number +
                          " failed to preview and might not get processed."
                      );
                    }
                  }}
                  className={`batchThumb ${
                    file.currentIndex === index ? "batchSelected" : null
                  }`}
                  src={url}
                />
              )}
            </div>
          );
        })}
      </Row>
    </Row>
  );
};

export default BatchPreview;
